import { HttpClient, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DocumentoPac} from '../model/DocumentoPac';
import {ColecaoPac} from '../model/ColecaoPac';
import {map} from 'rxjs/operators';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ResultadoOperacaoAditavel } from '../model/ResultadoOperacaoAditavel';
import { Aviso } from '../model/Aviso';
import { HistoricoTransacoesRealizadasView } from '../model/view/HistoricoTransacoesReralizadasView';
import { Aditivo } from '../model/Aditivo';

@Injectable({
  providedIn: 'root'
})
export class PacService {

  private BASE_URL = './rest/seguro/pac';

  constructor(private http: HttpClient) {
  }

  obterPac(idPac: string): Observable<DocumentoPac> {
    return this.http.get(`${this.BASE_URL}/${idPac}`, blockUi()).pipe(map(p => Object.assign(new DocumentoPac(), p)));
  }

  async obterPacPromisse(idPac: string): Promise<DocumentoPac>{
    var documento: DocumentoPac = new DocumentoPac
    await this.http.get<DocumentoPac>(`${this.BASE_URL}/${idPac}`, blockUi()).toPromise().then(docPac => documento = docPac)
    return documento;
  }

  pacComOperacaoAtiva(idPac: string): Observable<ResultadoOperacaoAditavel> {
//    idPac = '300039771';
    return this.http.get(`${this.BASE_URL}/${idPac}/isOperacaoAditavel`, blockUi()).pipe(map(p => Object.assign(new ResultadoOperacaoAditavel(), p)));
  }

  pesquisaPacAvancada(proposta: string, ano: number, pac: string, comprador: string): Observable<ColecaoPac> {
    let params = new HttpParams();
    if (proposta) {
      params = params.set('proposta', proposta);
    }
    if (ano) {
      params = params.set('ano', ano + '');
    }
    if (pac) {
      params = params.set('pac', pac);
    }
    if (comprador) {
      params = params.set('comprador', comprador);
    }

    return this.http.get(`${this.BASE_URL}/pesquisaAvancada/`, blockUi({params})).pipe(map(p => Object.assign(new ColecaoPac(), p)));
  }

  pesquisaPac(criterio: string): Observable<ColecaoPac> {
    let params = new HttpParams();
    if (criterio) {
      params = params.set('criterio', criterio);
    }
    return this.http.get(`${this.BASE_URL}/pesquisa/`, blockUi({params})).pipe(map(p => Object.assign(new ColecaoPac(), p)));
  }

  buscarAvisoCancelamentoSaldo(idPac: number, idTipo: number): Observable<Aviso>{
    let params = new HttpParams();
    if (idPac) {
      params = params.set('idpac', idPac);
      params = params.set('idtipo', idTipo);
    }
    return this.http.get<Aviso>(`${this.BASE_URL}/avisocancelamento`, blockUi({params})).pipe(map(p => Object.assign(Aviso, p)))
  }

  buscarAvisosAnalisePac(idPac: number): Observable<Aviso[]>{
    return this.http.get<Aviso[]>(`${this.BASE_URL}/avisos-analise-pac/${idPac}`, blockUi()).pipe();
  }

  buscarAvisosProtocoloPac(idPac: number): Observable<Aviso[]>{
    return this.http.get<Aviso[]>(`${this.BASE_URL}/avisos-protocolo-pac/${idPac}`, blockUi()).pipe();
  }

  buscarHistorico(idPac: number, tipoDoc: string): Observable<HistoricoTransacoesRealizadasView[]> {
    let params = new HttpParams();
    if (idPac) {
      params = params.set('idpac', idPac);
    }
    if (tipoDoc) {
      params = params.set('tipoDoc', tipoDoc);
    }

    return this.http.get<HistoricoTransacoesRealizadasView[]>(`${this.BASE_URL}/historico`, blockUi({params}))/*.pipe(map(p => Object.assign(new ColecaoHistorico(), p)))*/

  }

  buscarAditivo(idPac: number): Observable<Aditivo[]> {
    let params = new HttpParams();
    if (idPac) {
      params = params.set('idpac', idPac);
    }

    return this.http.get<Aditivo[]>(`${this.BASE_URL}/aditivo`, blockUi({params}))/*.pipe(map(p => Object.assign(new ColecaoHistorico(), p)))*/

  }
}
